<script lang="ts" setup>
import { useToast } from "@profeat/ui-kit";
import { $t as translate } from "~/i18n";

const { showToast } = useToast();
const copyFullUrl = async () => {
  try {
    let currentUrl = window.location.href;
    currentUrl += currentUrl.includes("?") ? '&source=mobile' : '?source=mobile';
    await navigator.clipboard.writeText(currentUrl);
    showToast({
      text: translate("mobileMockup.toast.linkCopied"),
      color: "success",
    });
  } catch (err) {
    showToast({
      text: translate("mobileMockup.toast.failedToCopyLink"),
      color: "error",
    });
  }
};
</script>

<template>
  <div class="mockup">
    <Logo />
    <div class="mockup-wrapper">
      <div class="mockup-wrapper-img">
        <img src="/src/assets/icons/maskote-from-mobile-auth.png" />
      </div>
      <div class="mockup-wrapper-text">
        <div class="mockup-wrapper-text-header">
          {{ $t("mobileMockup.hurrayYouRegistered") }}
        </div>
        <div class="mockup-wrapper-text-body">
          {{ $t("mobileMockup.campaignSetupFromPhone") }}
        </div>
      </div>
      <div class="mockup-wrapper-button">
        <PButton class="w-full" @click="copyFullUrl">{{
          $t("mobileMockup.copySignInLink")
        }}</PButton>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.mockup {
  background: var(--common-dark);
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;

  &-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 158px;
    gap: 40px;
    width: 328px;

    &-img {
      position: relative;
      width: 200px;
      height: 100px;
    }

    &-text {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 24px;
      color: var(--common-white, #fff);

      &-header {
        @include bold-22;
        text-align: center;
        width: 100%;
      }

      &-body {
        @include regular-14;
        text-align: center;
        width: 100%;
      }
    }

    &-button {
      width: 100%;
      margin-bottom: 16px;
    }
  }
}

@media screen and (max-width: 768px) {
  .mockup {
    box-sizing: border-box;
    padding: 0px 16px;
  }
}

/* Горизонтальная ориентация (телефон перевернут) */
@media (orientation: landscape) {
  .mockup {
    height: auto;
  }
}
</style>
